import styled, { css } from 'styled-components';

export const COLORS = {
  default: css`
    background: #2b3841;
    border: 1px solid #3d4952;
    color: #e6eaec;
    &:hover {
      background: #34444f;
      border-color: #47b972;
    }
    &:disabled:hover {
      background: #2b3841;
      border-color: #3d4952;
    }
  `,
  success: css`
    background: linear-gradient(90deg, #5cc98a 0%, #3aa863 100%);
    border: 1px solid #3aa863;
    color: #fff;
    &:hover {
      filter: brightness(1.06);
    }
  `,
  danger: css`
    background: linear-gradient(90deg, #d8434f 0%, #cc2936 100%);
    border: 1px solid #cc2936;
    color: #fff;
    &:hover {
      filter: brightness(1.06);
    }
  `,
};

export const FilledButtonStyled = styled.button`
  cursor: pointer;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  height: 40px;
  border-radius: 8px;
  padding: 0 20px;
  box-sizing: border-box;

  box-shadow: none;
  position: relative;
  transition:
    filter 0.15s ease-in,
    border-color 0.15s ease-in,
    background 0.15s ease-in;
  ${(props) => COLORS[props.$color] ?? COLORS.default}
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    &:hover {
      filter: none;
    }
  }

  &.loading::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.5) url(/images/loader.svg) no-repeat 50% 50%;
    background-size: 18px auto;
  }

  &.size-sm {
    height: 30px;
    padding: 0 10px;
  }
`;
